import React from 'react';
import { FaLinkedin, FaInstagram, FaFacebook, FaWhatsapp } from 'react-icons/fa';

const Footer = () => {
  return (
    <footer className="footer">
      <div className="container">
        <div className="footer-content">
          <div className="footer-section">
            <h3 className="footer-title">Cita Facil</h3>
            <p className="footer-text">Reserva con confianza, agenda con facilidad</p>
            <div className="social-links">
              <a 
                href="https://wa.me/34632215886" 
                target="_blank" 
                rel="noopener noreferrer" 
                className="social-link"
                aria-label="WhatsApp"
              >
                <FaWhatsapp />
              </a>
              <a 
                href="https://www.linkedin.com/in/mar%C3%ADa-gonz%C3%A1lez-8b46493a6/" 
                target="_blank" 
                rel="noopener noreferrer" 
                className="social-link"
                aria-label="LinkedIn"
              >
                <FaLinkedin />
              </a>
              <a 
                href="https://www.instagram.com/anastasia_perepelova/" 
                target="_blank" 
                rel="noopener noreferrer" 
                className="social-link"
                aria-label="Instagram"
              >
                <FaInstagram />
              </a>
              <a 
                href="https://www.facebook.com/profile.php?id=61581694923538" 
                target="_blank" 
                rel="noopener noreferrer" 
                className="social-link"
                aria-label="Facebook"
              >
                <FaFacebook />
              </a>
            </div>
          </div>
          <div className="footer-section">
            <h4 className="footer-heading">Enlaces Rápidos</h4>
            <ul className="footer-links">
              <li><a href="#home">Inicio</a></li>
              <li><a href="#about">Acerca de</a></li>
              <li><a href="#services">Servicios</a></li>
              <li><a href="#how-it-works">Cómo Funciona</a></li>
              <li><a href="#reviews">Reseñas</a></li>
              <li><a href="#contact">Contacto</a></li>
            </ul>
          </div>
          <div className="footer-section">
            <h4 className="footer-heading">Legal</h4>
            <ul className="footer-links">
              <li><a href="#privacy">Política de Privacidad</a></li>
              <li><a href="#disclaimer">Aviso Legal</a></li>
            </ul>
          </div>
        </div>
        <div className="footer-bottom">
          <p>&copy; 2024 Cita Facil. Todos los derechos reservados.</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
